export const isEmpty = function (value) {
  if (value === null || value === '' || value === undefined) return true
  return false
}

export const isNameValid = (fullName) => {
  // eslint-disable-next-line
  var re = /^[a-zA-Z\s]*$/
  return re.test(fullName)
}

export const isValidZipCode = (zipCode) => {
  return zipCode.length === 8
}

export const isValidPhone = (phone) => {
  if (phone.length === 0) return true
  // eslint-disable-next-line
  var re = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})\-?(\d{4}))$/
  return re.test(phone)
}

export const minHomeLength = (phone) => {
  return phone.length === 10 || phone.length === 0
}

export const minMobileLength = (phone) => {
  return phone.length === 11 || phone.length === 0
}

export const isValidCNPJ = (cnpj) => {
  if (cnpj.length === 0) return true
  cnpj = cnpj.replace(/[^\d]+/g, '')
  if (cnpj === '') return false
  if (cnpj.length !== 14) return false
  // Elimina CNPJs invalidos conhecidos
  if (cnpj === '00000000000000' || cnpj === '11111111111111' || cnpj === '22222222222222' || cnpj === '33333333333333' || cnpj === '44444444444444' || cnpj === '55555555555555' || cnpj === '66666666666666' || cnpj === '77777777777777' || cnpj === '88888888888888' || cnpj === '99999999999999') {
    return false
  }
  // Valida DVs
  var size = cnpj.length - 2
  var numbers = cnpj.substring(0, size)
  var dig = cnpj.substring(size)
  var sum = 0
  var pos = size - 7
  var i
  for (i = size; i >= 1; i--) {
    sum += numbers.charAt(size - i) * pos--
    if (pos < 2) {
      pos = 9
    }
  }
  var result = sum % 11 < 2 ? 0 : 11 - sum % 11
  if (result.toString() !== dig.charAt(0)) {
    return false
  }
  size = size + 1
  numbers = cnpj.substring(0, size)
  sum = 0
  pos = size - 7
  for (i = size; i >= 1; i--) {
    sum += numbers.charAt(size - i) * pos--
    if (pos < 2) {
      pos = 9
    }
  }
  result = sum % 11 < 2 ? 0 : 11 - sum % 11
  if (result.toString() !== dig.charAt(1)) {
    return false
  }
  return true
}

export const isValidCPF = (cpf) => {
  if (isEmpty(cpf)) return true
  // eslint-disable-next-line
  cpf = cpf.replace(/[^\d]+/g,'')
  if (cpf === '') return false
  // Elimina CPFs invalidos conhecidos
  if (cpf.length !== 11 || cpf === '00000000000' || cpf === '11111111111' || cpf === '22222222222' || cpf === '33333333333' || cpf === '44444444444' || cpf === '55555555555' || cpf === '66666666666' || cpf === '77777777777' || cpf === '88888888888' || cpf === '99999999999') {
    return false
  }
  var add, rev, i
  // Valida 1o digito
  add = 0
  for (i = 0; i < 9; i++) {
    add += parseInt(cpf.charAt(i)) * (10 - i)
  }
  rev = 11 - (add % 11)
  if (rev === 10 || rev === 11) {
    rev = 0
  }
  if (rev !== parseInt(cpf.charAt(9))) {
    return false
  }
  // Valida 2o digito
  add = 0
  for (i = 0; i < 10; i++) {
    add += parseInt(cpf.charAt(i)) * (11 - i)
  }
  rev = 11 - (add % 11)
  if (rev === 10 || rev === 11) {
    rev = 0
  }
  if (rev !== parseInt(cpf.charAt(10))) {
    return false
  }
  return true
}

const toDigits = numString =>
  numString
    .replace(/[^0-9]/g, '')
    .split('')
    .map(Number)

const condTransform = (predicate, value, fn) => {
  if (predicate) {
    return fn(value)
  } else {
    return value
  }
}

const doubleEveryOther = (current, idx) =>
  condTransform(idx % 2 === 0, current, x => x * 2)

const reduceMultiDigitVals = current =>
  condTransform(current > 9, current, x => x - 9)

export const isValidCard = (numString) => {
  if (!numString || numString === '') return false
  const digits = toDigits(numString)
  const len = digits.length
  const luhnDigit = digits[len - 1]
  const total = digits
    .slice(0, -1)
    .reverse()
    .map(doubleEveryOther)
    .map(reduceMultiDigitVals)
    .reduce((current, accumulator) => current + accumulator, luhnDigit)
  return total % 10 === 0
}

export const validateCvv = (brand, value) => {
  if (brand !== null || value === 1) {
    return this.card.cvv === this.brand.cvv
  }
  return false
}

export const isValidExpDate = (date) => {
  const month = date.substring(0, 2)
  var year = date.substring(3, 5)
  if (!(month && year) || (month === '' || year === '')) {
    return false
  }
  if (!/^\d+$/.test(month)) {
    return false
  }
  if (!/^\d+$/.test(year)) {
    return false
  }
  if (parseInt(month, 10) > 12 || parseInt(month, 10) === 0) {
    return false
  }
  if (year.length === 2) {
    var prefix = (new Date()).getFullYear()
    prefix = prefix.toString().slice(0, 2)
    year = prefix + year
  }
  // o 0 faz retornar o último dia do mês
  const expiration = new Date(year, month, 0)
  // ajusta hora de 00:00:00 para 23:59:59
  expiration.setHours(23, 59, 59)
  const current = new Date()
  const lessThan13 = expiration.getFullYear() - current.getFullYear() <= 13
  return expiration > current && lessThan13
}

export const validateDateFormat = (date) => {
  try {
    formatISODate(date)
    return true
  } catch {
    return false
  }
}

export const validateDocument = (document) => {
  return isValidCNPJ(document) || isValidCPF(document)
}

export const formatToInt = (value) => {
  if (typeof value === 'string') {
    return parseInt(value.replace(/R\$|\,|\./g, '')) // eslint-disable-line
  }
  if (value === null) return 0
  return value
}

export const formatToFloat = (value) => {
  if (typeof value === 'string') {
    return value.replace(/R\$|\./g, '').replace(/\,/g, '.') // eslint-disable-line
  }
  if (value === null) return 0
  return value
}

export const formatCurrency = (value) => {
  if (typeof value !== 'string') {
    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    })
    return formatter.format(value)
  }
  return value
}

export const formatDocument = (document) => {
  if (document !== undefined) {
    document = document.replace(/[^\d]/g, '')
    if (document.length === 11) return document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    if (document.length === 14) return document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
  }
  return document
}

export const formatZipCode = (zipCode) => {
  zipCode = zipCode.replace(/[^\d]/g, '')
  return zipCode.replace(/^(\d{5})(\d{3})/, '$1-$2')
}

export const formatPhoneNumber = (phone) => {
  phone = phone.replace(/[^\d]/g, '')
  if (phone.length === 11) return phone.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
  if (phone.length === 10) return phone.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
}

export const formatPhoneNumberToRequest = (phone) => {
  phone = phone.replace(/[^\d]/g, '')
  if (phone.length === 11) return phone.replace(/^(\d{2})(\d{9})/, '55 $1 $2')
  if (phone.length === 10) return phone.replace(/^(\d{2})(\d{8})/, '55 $1 $2')
}

export const maskCreditCard = (card, format = false) => {
  if (card.length === 16 && !format) return card.replace(/^(\d{4})(\d{4})(\d{4})(\d{4})/, '**** **** **** $4')
  if (card.length === 13 && !format) return card.replace(/^(\d{4})(\d{4})(\d{5})/, '**** **** $3')
  if (card.length === 16 && format) return card.replace(/^(\d{4})(\d{4})(\d{4})(\d{4})/, '$4')
  if (card.length === 13 && format) return card.replace(/^(\d{4})(\d{4})(\d{5})/, '$3')
}

export const formatDate = (date) => {
  date = (date.split('T')[0].split('-')).reverse().join('/')
  return date
}

export const formatISODate = (date) => {
  if (date.length === 10) return (new Date(date.split('/').reverse().join('-'))).toISOString()
  else return date
}

export const fromatParseDate = (date) => {
  date = date.split('/')
  return Date.parse(`${date[1]}/${date[0]}/${date[2]}`)
}

export const formatToIputDate = (date) => {
  return date.split('T')[0].split('-').reverse().join('/')
}

export const currentDate = (num = 0) => { return new Date(Date.now() + (num * 24 * 60 * 60000)) }

export const validateDate = (date) => {
  const value = new Date(date.split('/').reverse().join('-'))
  const today = new Date(Date.now() - 180 * 60000)
  return !(!(date.length === 10) || isNaN(value.getTime()) || value.getTime() < 0 || value.getTime() < today.getTime())
}

export const setCurrentDate = (num = 1) => {
  const date = new Date()
  let today
  if (isNaN(num)) num = 1
  if (num < 1) today = currentDate(num)
  else today = new Date(date)
  today.setDate(today.getDate() + parseInt(num))
  return today.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' }).split(' ')[0]
}

export const filterChar = (value) => {
  return value.replace('-', '')
}

export const minutesToMidnight = () => {
  var d = new Date()
  return parseInt((-d + d.setHours(24, 0, 0, 0)) / 6e4)
}

export const prepareItems = (items) => {
  const newItems = items.map(item => {
    const newItem = {
      quantity: parseInt(item.quantity),
      amount: formatToInt(item.amount),
      description: item.description
    }
    return newItem
  })
  return newItems
}

export const receiveItems = (items) => {
  items.map(item => {
    item.amount = formatCurrency(item.amount / 100)
  })
  return items
}

export const normalizeCharacteres = (value) => {
  return value.normalize('NFD').replace(/([\u0300-\u036f])/g, '').replace(/[^0-9a-zA-Z.,!\-\s]/g, '')
}

export const formatDateToLocalTime = (date) => {
  const formatedDate = date.split('/').reverse().join('-')
  const formatedHour = new Date().toLocaleTimeString()
  return new Date(formatedDate + ' ' + formatedHour).toISOString()
}

export const containsSpecialCharacters = (str) => {
  const specialChars = /[^A-Za-z0-9\s]+/g
  return specialChars.test(str)
}
